import React from 'react';
import PropTypes from 'prop-types';

const WebinarHeader = ({ webinar }) => (
    <div className="container-webinar-header" id="container-webinar-header">
        <div className="layout">
            <div className="page-webinar-header" id="page-webinar-header">
                <div className="webinar-header-logo-container">
                    <div className="webinar-header-logo" id="webinar-header-logo"/>
                </div>
                <div className="webinar-header" id="webinar-header">
                    <div className="webinar-header-title" id="webinar-header-title">{ webinar.header.title }</div>
                    <div className="webinar-header-subtitle" id="webinar-header-subtitle">{ webinar.header.subtitle }</div>
                    <div className="webinar-header-date" id="webinar-header-date">{ webinar.header.date }</div>
                </div>
            </div>
        </div>
    </div>
);

WebinarHeader.propTypes = {
    webinar: PropTypes.shape().isRequired
};

export default WebinarHeader;



// WEBPACK FOOTER //
// ./src/components/content/webinar/WebinarHeader.jsx